import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router";
import { Entry } from "./components/entry/Entry";
import { Home } from "./components/home/Home";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Entry />} />
        <Route path="/home" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
